import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

/** Shared shell for the Privacy Policy and Terms pages (public, dark theme). */
export default function LegalLayout({ title, updated, children, testid }) {
  return (
    <div className="min-h-screen landing-dark bg-surface-base text-white" data-testid={testid}>
      <nav className="crystal-glass sticky top-0 inset-x-0 z-50">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-home-link">
            <img src="/edge-logo.png" alt="Edge Training" className="h-9 w-9 rounded-lg" />
            <span className="font-heading text-lg tracking-tight leading-none text-white">EDGE TRAINING</span>
          </Link>
          <Link to="/" className="label-tiny text-white/70 hover:text-heat inline-flex items-center gap-1.5 transition-colors">
            <ArrowLeft size={13} /> HOME
          </Link>
        </div>
      </nav>

      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="mb-8">
          <div className="label-tiny text-heat mb-2">// LEGAL</div>
          <h1 className="font-heading text-4xl sm:text-5xl mb-2">{title}</h1>
          <p className="text-sm text-white/60">Last updated: {updated}</p>
        </div>

        <div className="mb-8 border border-amber-400/30 bg-amber-400/5 px-4 py-3 rounded-sm">
          <div className="label-tiny text-amber-400 mb-1">DRAFT — PENDING LEGAL REVIEW</div>
          <p className="text-[12px] leading-snug text-white/70">
            This is a working draft prepared to describe how the product operates. It is not legal advice
            and has not yet been reviewed by a lawyer. Items marked <span className="text-amber-400">[PLACEHOLDER]</span> must
            be completed with confirmed business details before publication.
          </p>
        </div>

        <div className="space-y-6 legal-body text-[14px] leading-relaxed text-white/85">
          {children}
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex items-center gap-4 label-tiny text-white/60">
          <Link to="/privacy" className="hover:text-heat transition-colors">PRIVACY</Link>
          <Link to="/terms" className="hover:text-heat transition-colors">TERMS</Link>
          <span>© 2026 Edge Training</span>
        </div>
      </div>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section>
      <h2 className="font-heading text-xl text-white mb-2">{heading}</h2>
      <div className="space-y-2 text-white/80">{children}</div>
    </section>
  );
}
